import { FC } from 'react';

import { Copy } from 'lucide-react';

import Button from '@mui/material/Button';

import { FingerprintModel } from 'v2/types/FingerprintModel';
import { copyText } from 'v2/utils';

interface SuspiciousUsersFingerprintColumnProps {
  fingerprint: FingerprintModel;
}

export const SuspiciousUsersFingerprintColumn: FC<SuspiciousUsersFingerprintColumnProps> = ({ fingerprint }) => {
  const handleCopy = () => {
    copyText(fingerprint.fingerprintId);
  };

  return (
    <Button onClick={handleCopy} endIcon={<Copy width={14} height={14} />}>
      {fingerprint.fingerprintId}
    </Button>
  );
};
